import axios from "axios";

export interface ScholarDashboardFilters {
  academicSessionId?: string;
  classId?: string;
  sectionId?: string;
}

export interface ScholarDashboardResponse {
  totalStudents: number;
  activeStudents: number;
  inactiveStudents: number;
  rteStudents: number;
  bplStudents: number;
  genderStats: Record<string, number>;
  classStats: { classId: string; class: string; students: number }[];
  sectionStats: { sectionId: string; section: string; students: number }[];
  categoryStats: { categoryId: string | null; category: string; students: number }[];
  recentAdmissions: {
    id: string;
    name: string;
    admissionNumber: string;
    class: string;
    section: string;
    admissionDate: string;
  }[];
}

export async function fetchScholarDashboard(
  filters: ScholarDashboardFilters,
): Promise<ScholarDashboardResponse> {
  const params: any = {};
  if (filters.academicSessionId) params.academicSessionId = filters.academicSessionId;
  if (filters.classId) params.classId = filters.classId;
  if (filters.sectionId) params.sectionId = filters.sectionId;

  const response = await axios.get<ScholarDashboardResponse>(
    "/scholar-register/dashboard",
    { params },
  );
  return response.data;
}

